module.exports = {
    welcome: "Welcome am",
    menu: "menu",
    home: "home",
    dashboard: "Dashboard",
    Posts: "Posts",
    Create: "Create",
    post: "post",
    view: "View",
    login: "Մուտք",
    language: "language",
    edit: "Խմբագրել",
    delete: "delete",
    action: "action",
    prefix: "prefix",
    save: "Պահպանել",
    categories: "categories",
    category: "category",
    seo: "Seo",
    title: "title",
    select: "Ընտրել",
    slug: "slug",
    short: "short",
    content: "content",
    table: "table",
    tables: "tables",
    quantity: "quantity",
    photo: "photo",
    choose: "choose",
    file: "file",
    update: "Թարմացված է",
    result: "Rresult",
    schema: "schema",
    database: "database",
    settings: "settings",
    controll: "controll",
    tariff: "tariff",
    add: "add",
    advices: "advices",
    advice: "advice",
    feedbacks: "feedbacks",
    active: "Active",
    inactive: "Inactive",
    activate: "Activate",
    deactivate: "Deactivate",
    /* nerqev */
    contact: "Կապ",
    contacts: "Կապ մեզ հետ",
    blog: "Բլոգ",
    about_as: "Մեր մասին",
    Just_3_simple_steps: "Ընդամենը 3 պարզ քայլ",
    download: "Ներբեռնել",
    Create_your_resume_right_now: "Ստեղծենք աշխատանքային ռեզյումե միասին",
    cv_editor_message: "Ռեզյումե ստեղծելու համար մենք խորհուրդ ենք տալիս օգտվել մեր կայքի ծառայություններից: Այն Ձեզ կտա հնարավորություն պարզ և արագ «նկարել» ռեզյումե, որին ձեր ապագա ղեկավարները անկասկած ուշադրություն կդարձնեն: Մեր կայքի հարմարավետ և պարզ ինտերֆեյսի շնորհիվ անգամ ամենաանփորձ օգտատերը կկարողանա ստեղծել վառ և հիշարժան ռեզյումե: Cvweb – ի օգտությաքմբ կազմված ռեզյումեները դուք հեշտությամբ կարող եք տեղադրել ցանկացած հարթակում և ուղարկել ցանկացած աշխատանքի համար:",
    Create_your_resume_large_text:
        "Ձեր «աշխատանքային այցեքարտի» ստեղծման համար CVWEB- ն առաջարկում է իդեալական և կրետիվ ռեզյումեի օրինակներ, որոնց միջոցով կարողեք ճիշտ ձևակերպել ձեր փորձը և ձեր ռեզյումեի նպատակը, քանի որ ձեր ապագա աշխատանքը անմիջականորեն կախված է դրա հետ: Փորձառու HR մասնագետները խորհուրդ են տալիս մեր կայքը՝ որպես լավագույններից մեկը, որտեղ յուրաքանչյուր դիմորդ կարող է գտնել իր սեփական ձևանմուշը աշխատանքի համար: Հետևելով մեր խորհուրդներին, Դուք կարողեք կազմել աչքի զարնող և ստեղծագործական ռեզյումե:",
    resume: "Ռեզյումե",
    created: "Ստեղծվել է",
    CV_in: "Ռեզյումե",
    minutes: "րոպեում",
    Popular_posts: "Լավագույն պոստեր",
    Our_advice: "Մեր խորհուրդները",
    bestsellers: "Ամենապահանջվածները",
    Your_feedbacks: "Ձեր կարծիքները",
    our_feedback: "Ձեր կարծիքը",
    Read_more: "Կարդալ ավելին",
    write_us: "Գրեք մեզ",
    create_resume: "Ստեղծեք ռեզյումե",
    send: "Ուղարկել",
    email_error: "սխալ Էլեկտրոնային փոստի հասցե",
    email: "Էլ․ փոստ",
    find_your_account: "Վերականգնել Ձեր պրոֆիլը",
    password: "Գաղտնաբառ",
    password_confirmation: "Գաղտնաբառի հաստատում",
    new_password: "Նոր գաղտնաբառ",
    registration: "Գրանցում",
    sign_in: "Մուտք",
    remamber_me: "Հիշել",
    forgot_password: "Մոռացե՞լ եք գաղտնաբառը",
    name: "Անուն",
    surname: "Ազգանուն",
    logout: "Ելք",
    change_password: "Փոխել գաղտնաբառը",
    old_password: "Հին գաղտնաբառ",
    basic_info: "Անձնական տվյալներ",
    job_stack: 'Աշխատանքային գրաֆիկ',
    profession: "Մասնագիտություններ",
    skills: "Հմտություններ",
    languages: "Լեզուներ",
    hobby: "Հոբբի",
    education: "Կրթություն",
    work_experience: "Աշխատանքային փորձ",
    social: 'Սոց. ցանցեր',
    citizen: "Քաղաքացիություն",
    cv_contact: "Կապ",
    career_objective: "Կարիերայի նպատակը",
    year: 'Տարի',
    phone: "Հեռախոս",
    birthday: "Ծննդյան օր",
    address: "Հասցե",
    start: "Սկիզբ",
    end: "Ավարտ",
    company: "Ընկերությունը",
    specialization: "Մասնագիտացում",
    degree: "Գիտ․ աստիճան",
    university: "Համալսարան",
    faculty: "Ֆակուլտետ",
    location: "Գտնվելու վայրը",
    description: "Նկարագրություն",
    from: 'Սկսած',
    full_stack: "Լրիվ",
    contractual: "Պայմանագրային",
    our_advices: 'Մեր խորհուրդները',
    category: "Կատեգորիա",
    we_in_social: "Մենք սոց․ ցանցերում",
    crweb_address: "Տպագրիչներ 4 <br><br> Երևան, Հայաստան 0010",
    vacancy: "Աշխատանք",
    present: "Ներկա ժամանակ",
    monthly: "Ամսական",
    select_empty: "Ցանկը դատարկ է",
    facebook_foot_link: "https://www.facebook.com/CVwebArmenia",
    instagram_foot_link: "https://www.instagram.com/cvwebarmenia",
    achievement: "Նվաճում",
    conditions: "Պայմանները",
    no_elements: "Ոչ մի տարր չի գտնվել:",
    CV_language:'Լեզուն',
    course:'֏',
    //errors
    invalid_email: 'Էլեկտրոնային հասցեն սխալ է',
    invalid_password: 'Գաղտնաբառը ընդունելի չէ',
    invalid_password_confirmation: 'Գաղտնաբառը չի համնկնում',
    policy : 'Գաղտնիության քաղաքականություն',
    policy_title : 'ԱՆՁՆԱԿԱՆ ՏՎՅԱԼՆԵՐԻ ՄՇԱԿՄԱՆ <br>ՔԱՂԱՔԱԿԱՆՈՒԹՅՈՒՆԸ «ԿՐԵԱՏԻՎ ՎԵԲ» ՍՊԸ',
    Last_edited : 'Ձեր ռեզյումեները',
    Zoom : 'Մոտեցնել',
    Rotation : 'Պտտացնել',
    teoken_sended : 'Վերականգնման հղումը ուղարկված է էլ. հասցեին:',
    please_verify : 'խնդրում եմ հաստատել',
    'The photo must be a file of type: jpeg, jpg, png.': 'Լուսանկարը պետք է լինի jpg, jpeg, png տիպի ֆայլ:',
    'The photo may not be greater than 10240 kilobytes.': 'Լուսանկարը չի կարող լինել ավելի քան 10 մեգաբայթ:',
    specialist_consultant: 'Մասնագետ-խորհրդատու',
    message_title:'Մուտքագրեք Ձեր հաղորդագրությունը',
    themes: "Տարբերակներ",
    sorry_404: 'Տվյալ էջը գոյություն չունի:',
    backtohomepage: 'Գլխավոր էջ',
    thanks_d: ' Շնորհակալություն<br> մեզ ընտրելու համար',
    payment_error: 'Վճարումը չի կատարվել, ստուգեք ձեր քարտի տվյալները և կրկին փորձեք',
    payment_message: 'Վճարման հաղորդագրություն',
    authentication_fails: 'Տվյալները ճիշտ չեն',
    day: 'օր',
    hour: 'ժ.',
    transfer: 'Փոխանցել',
    old_password_invalid: "Հին գաղտնաբառը սխալ է",
    attention: "Ուշադրություն",
    success: "Հաջողված է",
    changed: "Գաղտնաբառը փոխված է",
    recover: "Վերականգնել",
    error: "Անհաջող",
    FAQ: "ՀՏՀ",
    shear_text: "Կամ ասեք մեր մասին Ձեր ընկերներին եւ անվճար ստացեք սակագինը",
    registration_success: "Դուք հաջողությամբ գրանցվեցիք",
    server_error: "Փորձեք կրկին, ինչ-որ բան սխալ է",
    save_resume: "Ռեզյումեն պահպանվել է",
    cv_delete: "Ռեզյումեն ջնջված է",
    image_change: "Նկարը պահպանված է",
    sent_message: "Նամակը ուղարկվել է",
    input_promo_code: "Մուտքագրեք պրոմոկոդը",
    promo_code: "Պրոմոկոդը",
    new__cv: "Ստեղծել նորը",
    go__cvs: "Ստեղծված ռեզյումեներ",
    there__are__cv: "Դուք արդեն ունեք այդ տեսակի ռեզյումե։ <br/>Ցանկանում եք ստեղծել նո՞րը"
};



// WEBPACK FOOTER //
// ./resources/js/lang/am.js